// extracted by mini-css-extract-plugin
export default {"container":"conServices_container__Ay3h3","nameService":"conServices_nameService__jf0Vg","order":"conServices_order__dqaxs","services":"conServices_services__pwvII"};